import Vue from 'vue';
import UploadButton from 'vuetify-upload-button';
import UfDrawer from './components/Drawer.vue';
import UfToolbar from './components/Toolbar.vue';
import UfValue from './components/Value.vue';
import ImageGallery from "./components/ImageGallery.vue";
import RangeDetector from './components/RangeDetector.vue';
import VProgressGauge from './components/VProgressGauge.vue';

Vue.component('v-upload-btn', UploadButton);
Vue.component('v-progress-gauge', VProgressGauge);

Vue.component('uf-drawer', UfDrawer);
Vue.component('uf-toolbar', UfToolbar);
Vue.component('uf-value', UfValue);
Vue.component('image-gallery', ImageGallery);
Vue.component('range-detector', RangeDetector);
